<div class="multi-select-field">
  <!-- Label row with required indicator -->
  @if (label()) {
    <div class="multi-select-field__label-row">
      <label class="multi-select-field__label">{{ label() | translateLang }}@if (required()) {<span class="multi-select-field__required-asterisk">*</span>}</label>
    </div>
  }

  @if (description()) {
    <p class="multi-select-field__description">{{ description() }}</p>
  }

  <!-- PrimeNG MultiSelect -->
  <p-multiselect
    [(ngModel)]="value"
    [options]="options()"
    [optionLabel]="optionLabel()"
    [optionValue]="optionValue()"
    [placeholder]="placeholder() | translateLang"
    [maxSelectedLabels]="0"
    [selectedItemsLabel]="selectedItemsLabel()"
    [disabled]="disabled()"
    [filter]="filter()"
    [showToggleAll]="false"
    [ngClass]="{ 'p-invalid': isInvalid() }"
    [attr.aria-label]="effectiveAriaLabel() | translateLang"
    styleClass="multi-select-field__select"
    (onChange)="onChange($event)"
    (onBlur)="onBlur()"
    (onFocus)="onFocus()"
  >
    <!-- Dropdown icon template -->
    <ng-template pTemplate="dropdownicon">
      <app-icon name="chevron-down" [size]="10" color="#9F9696"></app-icon>
    </ng-template>

    <!-- Item template -->
    <ng-template let-option pTemplate="item">
      {{ option[optionLabel()] | translateLang }}
    </ng-template>
  </p-multiselect>

  <!-- Selected chips -->
  @if (selectedOptions().length > 0) {
    <div class="multi-select-field__chips-section">
      <span class="multi-select-field__chips-label">{{ chipsLabel() }}</span>
      <div class="multi-select-field__chips">
        @for (option of selectedOptions(); track option) {
          <div class="multi-select-field__chip">
            <span class="multi-select-field__chip-label">{{ option[optionLabel()] | translateLang }}</span>
            <button
              type="button"
              class="multi-select-field__chip-remove"
              (click)="removeItem(option)"
              [attr.aria-label]="'Remove ' + (option[optionLabel()] | translateLang)"
            >&#215;</button>
          </div>
        }
      </div>
    </div>
  }

  <!-- Error message -->
  @if (isInvalid()) {
    <div class="multi-select-field__error-message">
      {{ errorMessage() | translateLang }}
    </div>
  }
</div>
